import { watchOrder } from "@/mocks/siteContent";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-secondary-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-4">
            <i className="ri-route-line" aria-hidden="true"></i>
            新手入坑顺序
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            先看哪一版不容易劝退
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            各版本基本可以独立观看，没有硬性顺序。但如果你想让体验层层递进，可以按下面的节奏来，先低成本试水，再逐步深入。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {watchOrder.map((item) => (
            <li
              key={item.step}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-secondary-200/70 flex gap-4"
            >
              <span className="font-heading text-2xl md:text-3xl font-black text-secondary-400 shrink-0 leading-none">
                {item.step}
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}